import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';

const UploadableImageWrapper = styled.div`
  margin: 0 12px;
  max-width: 500px;
  width: 100%;
  height: 320px;
  user-select: none;

  input[type='file'] {
    display: none;
  }

  .no-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: ${mainColors.main_color_gradient};
    border-radius: 8px;
    transition: box-shadow 0.3s;

    &:hover {
      cursor: pointer;
      box-shadow: 0px 0px 10px 2px ${mainColors.text_color};
    }
  }

  .image-container {
    width: 100%;
    height: 100%;
    position: relative;

    &:hover .remove-button {
      opacity: 1;
    }
  }

  .preview-image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    object-position: center;
    image-rendering: auto;
    background: ${mainColors.main_color_rgba(0.3)};
  }

  .remove-button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: ${mainColors.main_color_rgba(0.6)};
    color: ${mainColors.text_color};
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 18px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s;

    &:hover {
      background: ${mainColors.main_color_rgba(0.8)};
    }
  }
`;

export default UploadableImageWrapper;
